<template>
  <div class="time-selector-main">
    <div class="time-selector-wrapper">
      <div class="time-selector">
        <div class="time-input">
          {{ compHours + ":" + compMins + " " + startTime.period }}
        </div>
        <div class="select__time">
          <div class="wraper__time">
            <span class="ico ico-up" @click="hourUp">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
            <span class="time-digit">
              <input
                v-model="startTime.hour"
                max="12"
                min="01"
                type="number"
                value="12"
              />
            </span>
            <span class="ico ico-down" @click="hourDown">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
          </div>
          <div class="ico ico-colon">
            <svg
              fill="none"
              height="32"
              viewBox="0 0 8 32"
              width="8"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z"
                fill="#474D52"
              />
              <path
                d="M4 32C6.20914 32 8 30.2091 8 28C8 25.7909 6.20914 24 4 24C1.79086 24 0 25.7909 0 28C0 30.2091 1.79086 32 4 32Z"
                fill="#474D52"
              />
            </svg>
          </div>
          <div class="wraper__time">
            <span class="ico ico-up" @click="minUp">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
            <span class="time-digit">
              <input
                v-model="startTime.mins"
                max="60"
                min="00"
                type="number"
                value="00"
              />
            </span>
            <span class="ico ico-down" @click="minDown">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
          </div>
          <div class="wraper__time">
            <span class="ico ico-up" @click="changeStartPeriod">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
            <span class="time-digit">
              {{ startTime.period }}
            </span>
            <span class="ico ico-down" @click="changeStartPeriod">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <span class="ico">
        <svg
          fill="none"
          height="2"
          viewBox="0 0 4 2"
          width="4"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.675172 1.204C0.531172 1.204 0.419172 1.168 0.339172 1.096C0.267172 1.024 0.231172 0.928 0.231172 0.808C0.231172 0.688 0.267172 0.592 0.339172 0.52C0.419172 0.44 0.531172 0.4 0.675172 0.4H3.31517C3.46717 0.4 3.57917 0.44 3.65117 0.52C3.73117 0.592 3.77117 0.688 3.77117 0.808C3.77117 0.928 3.73117 1.024 3.65117 1.096C3.57917 1.168 3.46717 1.204 3.31517 1.204H0.675172Z"
            fill="#474D52"
          />
        </svg>
      </span>
      <div class="time-selector">
        <div class="time-input">
          {{ compEndHours + ":" + compEndMins + " " + endTime.period }}
        </div>
        <div class="select__time">
          <div class="wraper__time">
            <span class="ico ico-up" @click="hourUpEnd">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
            <span class="time-digit">
              <input
                v-model="endTime.hour"
                max="12"
                min="01"
                type="number"
                value="12"
              />
            </span>
            <span class="ico ico-down" @click="hourDownEnd">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
          </div>
          <div class="ico ico-colon">
            <svg
              fill="none"
              height="32"
              viewBox="0 0 8 32"
              width="8"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z"
                fill="#474D52"
              />
              <path
                d="M4 32C6.20914 32 8 30.2091 8 28C8 25.7909 6.20914 24 4 24C1.79086 24 0 25.7909 0 28C0 30.2091 1.79086 32 4 32Z"
                fill="#474D52"
              />
            </svg>
          </div>
          <div class="wraper__time">
            <span class="ico ico-up" @click="minUpEnd">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
            <span class="time-digit">
              <input
                v-model="endTime.mins"
                max="60"
                min="00"
                type="number"
                value="00"
              />
            </span>
            <span class="ico ico-down" @click="minDownEnd">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
          </div>
          <div class="wraper__time">
            <span class="ico ico-up" @click="changeEndPeriod">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
            <span class="time-digit">
              {{ endTime.period }}
            </span>
            <span class="ico ico-down" @click="changeEndPeriod">
              <svg
                fill="none"
                height="8"
                viewBox="0 0 14 8"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="#474D52"
                  fill-rule="evenodd"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <button class="btn btn-secondary" @click="closeMe">Cancel</button>
      <button v-if="edit" class="btn btn-primary" @click="updateSlot">
        Update
      </button>
      <button v-else class="btn btn-primary" @click="addSlot">Add</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeSelector",
  data() {
    return {
      startTime: this.timeSlot
        ? { ...this.timeSlot.startTime }
        : {
            hour: "12",
            mins: "0",
            period: "AM"
          },
      endTime: this.timeSlot
        ? { ...this.timeSlot.endTime }
        : {
            hour: "12",
            mins: "0",
            period: "AM"
          }
    };
  },
  props: {
    timeSlot: {
      type: Object
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    compHours() {
      if (this.startTime.hour < 10) {
        if (this.startTime.hour == "0" || this.startTime.hour[0] != "0")
          return "0" + this.startTime.hour;
        else {
          return this.startTime.hour;
        }
      }
      return this.startTime.hour;
    },
    compMins() {
      if (
        this.startTime.mins === "0" ||
        (this.startTime.mins[0] !== "0" && this.startTime.mins.length === 1)
      )
        return "0" + this.startTime.mins;
      else {
        return this.startTime.mins;
      }
    },
    compEndHours() {
      if (this.endTime.hour < 10) {
        if (this.endTime.hour === "0" || this.endTime.hour[0] !== "0")
          return "0" + this.endTime.hour;
        else {
          return this.endTime.hour;
        }
      }
      return this.endTime.hour;
    },
    compEndMins() {
      if (
        this.endTime.mins === "0" ||
        (this.endTime.mins[0] !== "0" && this.endTime.mins.length === 1)
      )
        return "0" + this.endTime.mins;
      else {
        return this.endTime.mins;
      }
    }
  },
  methods: {
    closeMe() {
      console.log("closeMe");
      this.$emit("closeMe");
    },
    addSlot() {
      this.$emit("addSlot", {
        startTime: {
          hour: this.compHours,
          mins: this.compMins,
          period: this.startTime.period
        },
        endTime: {
          hour: this.compEndHours,
          mins: this.compEndMins,
          period: this.endTime.period
        }
      });
    },
    updateSlot() {
      console.log(this.timeSlot);
      this.$emit("updateSlot", {
        id: this.timeSlot.id,
        startTime: {
          hour: this.compHours,
          mins: this.compMins,
          period: this.startTime.period
        },
        endTime: {
          hour: this.compEndHours,
          mins: this.compEndMins,
          period: this.endTime.period
        }
      });
    },
    hourUpEnd() {
      this.endTime.hour =
        +this.endTime.hour < 12
          ? (+this.endTime.hour + 1).toString()
          : (this.endTime.hour = "1");
    },
    hourDownEnd() {
      this.endTime.hour =
        +this.endTime.hour > 1
          ? (+this.endTime.hour - 1).toString()
          : (this.endTime.hour = "12");
    },
    minUpEnd() {
      this.endTime.mins =
        +this.endTime.mins < 59
          ? (+this.endTime.mins + 1).toString()
          : (this.endTime.mins = "0");
    },
    minDownEnd() {
      this.endTime.mins =
        +this.endTime.mins > 0
          ? (+this.endTime.mins - 1).toString()
          : (this.endTime.mins = "59");
    },
    changeEndPeriod() {
      this.endTime.period = this.endTime.period === "AM" ? "PM" : "AM";
    },
    hourUp() {
      this.startTime.hour =
        +this.startTime.hour < 12
          ? (+this.startTime.hour + 1).toString()
          : (this.startTime.hour = "1");
    },
    hourDown() {
      this.startTime.hour =
        +this.startTime.hour > 1
          ? (+this.startTime.hour - 1).toString()
          : (this.startTime.hour = "12");
    },
    minUp() {
      this.startTime.mins =
        +this.startTime.mins < 59
          ? (+this.startTime.mins + 1).toString()
          : (this.startTime.mins = "0");
    },
    minDown() {
      this.startTime.mins =
        +this.startTime.mins > 0
          ? (+this.startTime.mins - 1).toString()
          : (this.startTime.mins = "59");
    },
    changeStartPeriod() {
      this.startTime.period = this.startTime.period === "AM" ? "PM" : "AM";
    }
  },
  watch: {
    "startTime.hour"(newVal) {
      if (newVal.length > 2) {
        this.startTime.hour = newVal.substr(0, 2);
      }
    },
    "startTime.mins"(newVal) {
      if (newVal.length > 2) {
        this.startTime.mins = newVal.substr(0, 2);
      }
    },
    "endTime.hour"(newVal) {
      if (newVal.length > 2) {
        this.endTime.hour = newVal.substr(0, 2);
      }
    },
    "endTime.mins"(newVal) {
      if (newVal.length > 2) {
        this.endTime.mins = newVal.substr(0, 2);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.time-selector-main {
  z-index: 8;
  position: absolute;
  top: 100%;
  left: 0%;
  background-color: #fff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;

  .time-selector-wrapper {
    padding: 16px;
    display: flex;
    column-gap: 10px;

    & > .ico {
      padding-top: 12px;
    }

    .time-selector {
      * {
        user-select: none; /* standard syntax */
        -webkit-user-select: none; /* webkit (safari, chrome) browsers */
        -moz-user-select: none; /* mozilla browsers */
        -khtml-user-select: none; /* webkit (konqueror) browsers */
        -ms-user-select: none; /* IE10+ */
      }

      .time-input {
        // input {
        background: #ffffff;
        border-radius: 32px;
        border: 1px solid #ddd;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 7px;
        margin: 4px 0;

        h5 {
          font-family: "Nunito", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          text-align: center;
          color: #474d52;
          margin: 0;
        }

        // }
      }

      .select__time {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .wraper__time {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        border-radius: 4px;
        margin: 0px 3px;

        span {
          height: 30px;
          width: 45px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;

          &.ico-up {
            &:after {
              content: "";
              width: 90%;
              left: 50%;
              transform: translateX(-50%);
              bottom: 0;
              position: absolute;
              border-bottom: 1px solid #dddddd;
            }
          }

          &.ico-down {
            &:after {
              content: "";
              width: 90%;
              left: 50%;
              transform: translateX(-50%);
              top: 0;
              position: absolute;
              border-bottom: 1px solid #dddddd;
            }
          }

          &.time-digit {
            height: 33px;
            color: #474d52 !important;

            input {
              border: none;
              text-align: center;

              &:focus {
                outline: none;
              }
            }

            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }

            /* Firefox */
            input[type="number"] {
              -moz-appearance: textfield;
            }
          }
        }
      }
    }
  }

  .foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-top: 1px solid #dddddd;

    .btn-primary,
    .btn-secondary {
      /* primary-light */
      border: 1px solid rgba(85, 126, 251, 0.1);
      background: rgba(85, 126, 251, 0.1);
      border-radius: 100px;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--theme-color);
      max-width: 110px;
      width: 100%;
    }

    .btn-secondary:hover {
      background: var(--theme-color);
      color: #fff;
    }

    .btn-primary {
      color: #fff;
    }
  }
}
</style>
